import * as React from "react";
import PropTypes from 'prop-types';

const SvgLockCp = props => {
  if (props.id !== "_svglockcp") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 54 78" fill="none" {...props}><g clipPath="url(#lockCP_svg__clip0_1562_234698)" stroke="#C00" strokeWidth={1.771} strokeLinecap="round" strokeLinejoin="round"><path d="M38.283 76.552H16.247c-8.095 0-14.668-6.614-14.668-14.761V33.115h51.14v28.913c0 8.019-6.468 14.528-14.436 14.528v-.004zM15.963 33.114V20.53c0-6.378 5.155-11.547 11.515-11.547 6.458 0 11.695 5.252 11.695 11.728v5.176a4.111 4.111 0 008.129.034v-6.227c0-10.248-8.286-18.556-18.506-18.556H25.92c-10.123 0-18.326 8.226-18.326 18.375v13.602" /><path d="M31.006 57.858a6.919 6.919 0 003.058-5.748 6.922 6.922 0 00-6.919-6.928 6.922 6.922 0 00-6.918 6.927 6.919 6.919 0 003.058 5.75l-1.649 8.91a1.644 1.644 0 001.615 1.943h7.785a1.642 1.642 0 001.615-1.944L31 57.858h.005z" /></g><defs><clipPath id="lockCP_svg__clip0_1562_234698"><path fill="#fff" d="M0 0h53.67v78H0z" /></clipPath></defs></svg>;
};

SvgLockCp.displayName = "_svglockcp";
SvgLockCp.propTypes = {
  id: PropTypes.string
};
SvgLockCp.defaultProps = {
  id: ''
};
export default SvgLockCp;